import { render, staticRenderFns } from "./singleWindow.vue?vue&type=template&id=6d01d9a5&"
import script from "./singleWindow.vue?vue&type=script&lang=js&"
export * from "./singleWindow.vue?vue&type=script&lang=js&"
import style0 from "./singleWindow.vue?vue&type=style&index=0&id=6d01d9a5&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports